(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = [
    '.header__icon',
    '.template-product .product-form__buttons .button',
    '.template-product .shopify-payment-button__button',
    '.template-collection .quick-add__submit',
    '.template-search .quick-add__submit',
    '.template-cart .cart__checkout-button'
  ].join(',');

  const prepare = (root = document) => {
    if (!finePointer.matches || reduceMotion.matches) return;
    root.querySelectorAll(selector).forEach((element) => {
      if (element.dataset.storeInteractionReady === 'true') return;
      element.dataset.storeInteractionReady = 'true';
      element.classList.add('store-magnetic');

      element.addEventListener('pointermove', (event) => {
        const rect = element.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const magneticX = ((x / rect.width) - 0.5) * 7;
        const magneticY = ((y / rect.height) - 0.5) * 5;
        element.style.setProperty('--store-pointer-x', `${x}px`);
        element.style.setProperty('--store-pointer-y', `${y}px`);
        element.style.setProperty('--store-magnetic-x', `${magneticX.toFixed(2)}px`);
        element.style.setProperty('--store-magnetic-y', `${magneticY.toFixed(2)}px`);
      });

      element.addEventListener('pointerleave', () => {
        element.style.setProperty('--store-magnetic-x', '0px');
        element.style.setProperty('--store-magnetic-y', '0px');
      });
    });
  };

  const start = () => {
    prepare();
    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.(selector)) prepare(node.parentElement || document);
        else prepare(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

